'use client';

import React from 'react';
import { AlertOctagon } from 'lucide-react';

export const ResponsibleTradingWarning: React.FC = () => {
  return (
    <div className="w-full bg-slate-950/90 border-t border-slate-800/80 text-slate-400 py-2.5 px-4 text-xs">
      <div className="max-w-7xl mx-auto flex items-center justify-center space-x-2 text-center">
        <AlertOctagon className="w-4 h-4 text-amber-500 flex-shrink-0" />
        <p className="leading-tight">
          <strong className="text-amber-400 font-semibold">Responsible Trading Notice:</strong>{' '}
          AI-generated trading signals are probabilistic and do not guarantee profit. Trading involves risk, including loss of capital. Risk controls reduce exposure but cannot eliminate losses.
        </p>
      </div>
    </div>
  );
};

export default ResponsibleTradingWarning;
